The details of a person's employment, work, or relevant experience.
